import * as gleam from '../../gleam.mjs'

export function questionsContainerHeight(elementId) {
  const element = document.getElementById('question-' + elementId)
  if (!element) return new gleam.Error()
  const node = document.getElementById('questions-container')
  if (!node) return new gleam.Error()
  const height = node.getBoundingClientRect().height
  const dimension = node.scrollHeight
  return new gleam.Ok([element.offsetTop, dimension, height])
}

export function onResize(dispatch) {
  window.addEventListener('resize', event => {
    dispatch([window.innerWidth, window.innerHeight])
  })
}
